import React from "react";

export function ProductSkeleton({ count = 4 }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-7">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="card-luxe" data-testid="product-skeleton">
                    <div className="aspect-[4/5] bg-[color:var(--beige)]/60 animate-pulse" />
                    <div className="p-4 space-y-2">
                        <div className="h-3 w-16 bg-[color:var(--beige)]/70 animate-pulse" />
                        <div className="h-4 w-3/4 bg-[color:var(--beige)]/70 animate-pulse" />
                        <div className="h-3 w-1/2 bg-[color:var(--beige)]/70 animate-pulse" />
                    </div>
                </div>
            ))}
        </div>
    );
}

export function RowSkeleton({ count = 3 }) {
    return (
        <div className="space-y-3">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="h-14 bg-[color:var(--beige)]/60 animate-pulse" />
            ))}
        </div>
    );
}
